<template>
    <v-container class="fill-height align-start" fluid>
        <v-row justify="center" align="center" class="mt-5">
            <v-col cols="12" class="text-center mb-5">
                <h1 class="display-1 font-weight-bold primary--text">
                    <v-icon large color="primary" class="mr-2">mdi-golf</v-icon>
                    {{ $t('golf_administration') }}
                </h1>
                <p class="subtitle-1 grey--text">{{ $t('select_option_admin') }}</p>
            </v-col>

            <!-- Card: Canchas -->
            <v-col cols="12" sm="6" md="4" lg="3">
                <v-hover v-slot="{ hover }">
                    <v-card class="mx-auto transition-swing" :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }"
                        link to="/golf/courts" height="200">
                        <v-card-text class="d-flex flex-column align-center justify-center fill-height">
                            <v-avatar color="green lighten-5" size="80" class="mb-3">
                                <v-icon x-large color="green darken-2">mdi-golf-tee</v-icon>
                            </v-avatar>
                            <h2 class="headline font-weight-medium text--primary">{{ $t('golf_courts') }}</h2>
                            <span class="caption grey--text mt-1">{{ $t('manage_golf_course') }}</span>
                        </v-card-text>
                    </v-card>
                </v-hover>
            </v-col>

            <!-- Card: Reservaciones -->
            <v-col cols="12" sm="6" md="4" lg="3">
                <v-hover v-slot="{ hover }">
                    <v-card class="mx-auto transition-swing" :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }"
                        link to="/golf/reservations" height="200">
                        <v-card-text class="d-flex flex-column align-center justify-center fill-height">
                            <v-avatar color="blue lighten-5" size="80" class="mb-3">
                                <v-icon x-large color="blue darken-2">mdi-calendar-clock</v-icon>
                            </v-avatar>
                            <h2 class="headline font-weight-medium text--primary">{{ $t('golf_reservations') }}</h2>
                            <span class="caption grey--text mt-1">{{ $t('manage_reservations') }}</span>
                        </v-card-text>
                    </v-card>
                </v-hover>
            </v-col>

            <!-- Card: Lista Negra -->
            <v-col cols="12" sm="6" md="4" lg="3">
                <v-hover v-slot="{ hover }">
                    <v-card class="mx-auto transition-swing" :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }"
                        link to="/golf/blacklist" height="200">
                        <v-card-text class="d-flex flex-column align-center justify-center fill-height">
                            <v-avatar color="red lighten-5" size="80" class="mb-3">
                                <v-icon x-large color="red darken-2">mdi-account-cancel</v-icon>
                            </v-avatar>
                            <h2 class="headline font-weight-medium text--primary">{{ $t('golf_blacklist') }}</h2>
                            <span class="caption grey--text mt-1">{{ $t('manage_blacklist') }}</span>
                        </v-card-text>
                    </v-card>
                </v-hover>
            </v-col>

            <!-- Card: Caddies -->
            <v-col cols="12" sm="6" md="4" lg="3">
                <v-hover v-slot="{ hover }">
                    <v-card class="mx-auto transition-swing" :elevation="hover ? 12 : 2" :class="{ 'on-hover': hover }"
                        link to="/golf/caddies" height="200">
                        <v-card-text class="d-flex flex-column align-center justify-center fill-height">
                            <v-avatar color="orange lighten-5" size="80" class="mb-3">
                                <v-icon x-large color="orange darken-2">mdi-account-tie</v-icon>
                            </v-avatar>
                            <h2 class="headline font-weight-medium text--primary">{{ $t('golf_caddies') }}</h2>
                            <span class="caption grey--text mt-1">{{ $t('manage_caddies') }}</span>
                        </v-card-text>
                    </v-card>
                </v-hover>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
  name: 'GolfDashboard'
}
</script>

<style scoped>
.on-hover {
    transform: translateY(-5px);
}

.transition-swing {
    transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
</style>
